/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const RemoteIcon = createIcon({
  displayName: "RemoteIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.76256 2.17663C7.44598 1.49321 8.55402 1.49321 9.23744 2.17663L14.2374 7.17663C14.5656 7.50481 14.75 7.94993 14.75 8.41406V12.9998C14.75 13.9663 13.9665 14.7498 13 14.7498H3C2.0335 14.7498 1.25 13.9663 1.25 12.9998V8.41406C1.25 7.94993 1.43437 7.50481 1.76256 7.17663L6.76256 2.17663ZM8.17678 3.23729C8.07915 3.13965 7.92085 3.13965 7.82322 3.23729L2.82322 8.23729C2.77634 8.28417 2.75 8.34776 2.75 8.41406V12.9998C2.75 13.1379 2.86193 13.2498 3 13.2498H13C13.1381 13.2498 13.25 13.1379 13.25 12.9998V8.41406C13.25 8.34776 13.2237 8.28417 13.1768 8.23729L8.17678 3.23729Z"
        fill="currentColor"
      />
    </g>
  )
});
